import {Navigate, Route, Routes} from 'react-router-dom';
import {useCurrentWorkspaceUrlPrefix} from '@tinct/core-workspace';
import {ListCampaignsPage} from '../pages/list-campaigns-page/list-campaigns-page';
import {DetailsCampaignPage} from '../pages/details-campaign-page/details-campaign-page';
import {AnalyticsTab} from '../pages/details-campaign-page/tabs/analytics-tab';
import {LandingPagesTab} from '../pages/details-campaign-page/tabs/landing-pages-tab';
import {SettingsTab} from '../pages/details-campaign-page/tabs/settings-tab';
import {LeadsTab} from '../pages/details-campaign-page/tabs/leads-tab';
import {DetailsVariantPage} from '../pages/details-variant-page/details-variant-page';
import {VariantAnalyticsTab} from '../pages/details-variant-page/tabs/variant-analytics-tab';
import {VariantTrackedEventsTab} from '../pages/details-variant-page/tabs/variant-tracked-events-tab';
import {NEW_CAMPAIGN_DIALOG_HASH} from '../modals/new-campaign-dialog/new-campaign-dialog';

// The dedicated new-campaign screen was replaced by the globally available
// NewCampaignDialog. Deep links (and the configure chat's fallback) land here
// and open the dialog over the campaigns list instead.
const NewCampaignRedirect = () => {
  const workspaceUrlPrefix = useCurrentWorkspaceUrlPrefix();
  return (
    <Navigate
      to={{pathname: `${workspaceUrlPrefix}/campaigns`, hash: NEW_CAMPAIGN_DIALOG_HASH}}
      replace
    />
  );
};

export const CampaignsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ListCampaignsPage />} />
      <Route path="/new" element={<NewCampaignRedirect />} />
      <Route path="/:id" element={<DetailsCampaignPage />}>
        <Route index element={<AnalyticsTab />} />
        <Route path="landing-pages" element={<LandingPagesTab />} />
        <Route path="leads" element={<LeadsTab />} />
        <Route path="settings" element={<SettingsTab />} />
      </Route>
      <Route path="/:id/landing-pages/:variantId" element={<DetailsVariantPage />}>
        <Route index element={<VariantAnalyticsTab />} />
        <Route path="tracked-events" element={<VariantTrackedEventsTab />} />
      </Route>
    </Routes>
  );
};

